import { post } from "@src/appV2/api/api";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation } from "@tanstack/react-query";
import { z } from "zod";

export function useRecordShiftBlastVisit() {
  return useMutation({
    mutationFn: async (params: { shiftId: string }) => {
      const response = await post({
        url: `/shifts/${params.shiftId}/blast/worker-url-visits`,
        data: {},
        requestSchema: z.object({}),
        responseSchema: z.object({}),
      });

      return response.data;
    },
    meta: { logErrorMessage: APP_V2_APP_EVENTS.SHIFT_BLAST_VISIT_RECORD_FAILURE },
  });
}
